import { initializeApp } from "firebase/app";
import { getFirestore, getDocs, collection, query, onSnapshot, orderBy, doc, updateDoc, addDoc, limit, startAfter, where, writeBatch } from "firebase/firestore";

// Importa Auth
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBOoOYObOVvzbPZOD876r78rnu4Rrt2IvY",
    authDomain: "xeroo-demasled.firebaseapp.com",
    projectId: "xeroo-demasled",
    storageBucket: "xeroo-demasled.firebasestorage.app",
    messagingSenderId: "802121173421",
    appId: "1:802121173421:web:691ac51d10dd20605b7924"
};


// export const app = getApps().length        // ← reutiliza si ya existe
//     ? getApp()
//     : initializeApp(firebaseConfig);

// // Inicializa Firebase
// // const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);
// const auth = getAuth(app);

// // Exporta las funciones necesarias
// export { db, collection, query, onSnapshot, getDocs, orderBy, doc, updateDoc, addDoc, auth, limit, startAfter, where };


// Inicializa Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Exporta las funciones necesarias
export { db, collection, query, onSnapshot, getDocs, orderBy, doc, updateDoc, addDoc, auth, limit, startAfter, where, writeBatch, storage };
